export const STATUS = {
  END_MEETING: 0,
  COMING_MEETING: 1,
  NOT_YET_TIME_MEETING: 2
}

export const ISSUE_STATUS = { COMPLETED: 0, ON_GOING: 1, WAITING: 2 }

export const FACILITY_STATUS = { ACTIVE: 0, INACTIVE: 1, CLOSE: 2 }